module.exports = __webpack_public_path__ + "img/mg-live.557662ba.png";